const theme = {
  textPrimary: '#e6e6e6',
  textSecondary: '#b4b4b4',
  background: '#303030',
}
export default theme
